export var formatPhoneNumber = function (input, length) {
    if (length === void 0) { length = 10; }
    // Remove all non-numeric characters
    var cleaned = input === null || input === void 0 ? void 0 : input.toString().replace(/\D/g, "");
    // Check if the input is valid
    if ((cleaned === null || cleaned === void 0 ? void 0 : cleaned.length) !== length) {
        //console.log(input,"Input must be a 10-digit number.");
        return "";
    }
    else {
        // Format the number
        var formatted = "(".concat(cleaned.slice(0, 3), ") ").concat(cleaned.slice(3, 6), "-").concat(cleaned.slice(6));
        return formatted;
    }
};
